/**
 * 消息/会话行操作菜单的懒加载壳（21ag；EncryptionDialogsLazy 同构）。
 *
 * 菜单只有长按/右键才出现，却被首屏的消息列表与会话列表同时引用——放在首屏块
 * 里纯占预算（首屏 JS 卡在 80KB 线上，PROMPT 的处置顺序是先拆懒块）。
 * 加载期间什么都不渲染；块是本地的，长按到菜单之间通常一帧内。
 */
import { useLazyModule } from './useLazyModule';
import type { MessageMenuProps } from './MessageMenu';

export type { MenuItemAction, MessageMenuProps } from './MessageMenu';

export function MessageMenuLazy<Id extends string>(props: MessageMenuProps<Id>) {
  const { mod } = useLazyModule(() => import('./MessageMenu'));
  if (mod === null) return null;
  return <mod.MessageMenu {...props} />;
}
